import axios from 'axios';

const IMAGE_UPLOAD_URL =
  process.env.REACT_APP_IMAGE_UPLOAD_URL ||
  'https://t8rlaxfneb.execute-api.ap-south-1.amazonaws.com/prod/';
const BUCKET = process.env.REACT_APP_IMAGE_UPLOAD_BUCKET || 'rietail-file-upload';

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
const MAX_SIZE = 3 * 1024 * 1024; // 3 MB

const validateImage = (file: File): string | null => {
  if (!ALLOWED_TYPES.includes(file.type)) {
    return 'Only JPEG, PNG, JPG and WEBP images are allowed.';
  }
  if (file.size > MAX_SIZE) {
    return 'File exceeds the 3 MB limit.';
  }
  return null;
};

export interface UploadResult {
  url: string;
  imageName: string | null;
}

/**
 * Uploads an image to the shared rietail upload endpoint. `path` lets the
 * caller group uploads (e.g. "product", "product-gallery", "variant",
 * "collection") so files land in a tidy bucket prefix.
 */
export async function uploadImage(
  file: File,
  clientId: string | null | undefined,
  path: string = 'product'
): Promise<UploadResult> {
  const error = validateImage(file);
  if (error) throw new Error(error);

  const formData = new FormData();
  formData.append('single', file);

  const url = `${IMAGE_UPLOAD_URL}rietailimageupload?bucket=${BUCKET}&path=default/${path}`;

  const response = await axios.put(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'client-id': clientId || '',
      'web-site': '1',
    },
  });

  return {
    url: response.data?.url ?? '',
    imageName: response.data?.originalName ?? null,
  };
}
